/**
 * LinkedInButton — small clickable LinkedIn logo that opens the URL in
 * a new tab.  Renders nothing if no url is provided so callers can drop
 * it unconditionally next to a name.
 *
 * Usage:
 *   <LinkedInButton url={contact.linkedin_url} size={14}/>
 */
import React from 'react';

export default function LinkedInButton({ url, size = 14, label }) {
  if (!url) return null;
  // Normalise a bare slug like "in/foo" into a full URL
  let href = url.trim();
  if (!href.startsWith('http')) href = `https://${href.replace(/^\/+/, '')}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      onClick={(e) => e.stopPropagation()}
      data-testid="linkedin-button"
      className="inline-flex items-center justify-center rounded text-[#0A66C2] hover:text-[#004182] hover:bg-[#E8F1FB] transition-colors"
      style={{ width: size + 6, height: size + 6 }}
      title={label || 'Open LinkedIn profile'}
      aria-label={label || 'Open LinkedIn profile'}
    >
      {/* Official LinkedIn glyph */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M20.447 20.452H16.89v-5.569c0-1.328-.025-3.037-1.851-3.037-1.853 0-2.136 1.446-2.136 2.939v5.667H9.346V9h3.414v1.561h.049c.476-.9 1.637-1.852 3.37-1.852 3.602 0 4.268 2.37 4.268 5.455v6.288zM5.337 7.433a2.062 2.062 0 1 1 0-4.125 2.063 2.063 0 0 1 0 4.125zM7.119 20.452H3.554V9h3.565v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.225.792 24 1.771 24h20.451C23.2 24 24 23.225 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    </a>
  );
}
